export const cost = [
    {value: '100000 ' , label: 'Не превышает 90 млн. руб.' },
    {value: '500000', label: 'Не превышает 500 млн. руб.' },
    {value: '1500000 ' , label: 'Не превышает 3 млрд. руб.' },
    {value: '2000000 ', label: 'Не превышает 10 млрд. руб.' },
    {value: '5000000' , label: '10 млрд. руб. и более' },
   
];